import { render, staticRenderFns } from "./AdminChat.vue?vue&type=template&id=249601fe&"
import script from "./AdminChat.vue?vue&type=script&lang=js&"
export * from "./AdminChat.vue?vue&type=script&lang=js&"
import style0 from "./AdminChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports